import { Injectable, inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer, switchMap, catchError, EMPTY, filter, fromEvent, map, startWith, distinctUntilChanged } from 'rxjs';
import { APP_VERSION } from '../version';

const CHECK_INTERVAL_MS = 60_000;

@Injectable({ providedIn: 'root' })
export class VersionCheckService implements OnDestroy {
  private readonly http = inject(HttpClient);
  private sub: Subscription | null = null;

  startPolling(): void {
    if (this.sub || (APP_VERSION as string) === 'dev') return;

    const visible$ = fromEvent(document, 'visibilitychange').pipe(
      map(() => document.visibilityState === 'visible'),
      startWith(document.visibilityState === 'visible'),
      distinctUntilChanged(),
    );

    this.sub = visible$.pipe(
      switchMap((visible) =>
        visible
          ? timer(CHECK_INTERVAL_MS, CHECK_INTERVAL_MS).pipe(
              switchMap(() =>
                this.http.get<{ version: string }>(`/version.json?_=${Date.now()}`).pipe(
                  catchError(() => EMPTY),
                ),
              ),
              filter((res) => !!res.version && res.version !== APP_VERSION),
            )
          : EMPTY,
      ),
    ).subscribe(() => {
      location.reload();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
